/**
 * components/hazard/RefLink.js — «Лавлах сан» руу очих жижиг холбоос.
 *
 * Зөрчил бүртгэх маягтын сонголтууд БҮГД лавлахаас ирдэг. Сонгох зүйл
 * нь дутуу/буруу байвал хэрэглэгч хаанаас засахаа мэдэхгүй тул хэсэг
 * бүрийн толгойд эх сурвалж руу нь заасан холбоос тавина.
 *
 * ⚠ ШИНЭ ЦОНХОНД нээнэ (`target="_blank"`). Бөглөж байгаа маягт нь
 *   модал дотор бөгөөд хуудас солиход БҮХ бичсэн зүйл алдагдана —
 *   зөвхөн лавлах харах гэж орсон хүн ажлаа алдах ёсгүй.
 *
 * ⚠ antd `<Button type="primary" href=…>` нь `<a>` болж хувирахдаа
 *   цагаан текстээ алддаг (энэ төслийн antd 4.24 дээр батлагдсан) тул
 *   энгийн `<a>` ашиглав.
 */
import React from "react";

/**
 * Хяналт шалгалтын лавлахын «Ноцтой бус зөрчил» хэсэг — төрөл, заалт,
 * арга хэмжээ, шийтгэл.
 *
 * ⚠ 2026-09-23-нд `/risk/reference/checklist`-ээс ХЯНАЛТ ШАЛГАЛТЫН ЛАВЛАХ
 *   (`/incident/reference?tab=violation_ref`) руу зөөгдсөн: тэр хуудас нь
 *   шалгах хуудасны АСУУМЖ (15 критик, 5А) удирддаг бол зөрчлийн заалт/
 *   төрөл/арга хэмжээ нь хяналт шалгалт·зөрчлийн ажилд хэрэглэгддэг.
 */
export const VIOLATION_REF_URL = "/incident/reference?tab=violation_ref";

export default function RefLink({
  href = VIOLATION_REF_URL,
  children = "Лавлах сан",
  title = "Шинэ цонхонд нээнэ — бөглөсөн маягт хэвээр үлдэнэ",
}) {
  return (
    <a
      href={href}
      target="_blank"
      rel="noopener noreferrer"
      title={title}
      style={{
        fontSize: 11.5,
        fontWeight: 600,
        color: "#0F6E56",
        whiteSpace: "nowrap",
      }}
    >
      <i className="fas fa-external-link-alt" style={{ marginRight: 4 }} />
      {children}
    </a>
  );
}
